<template>
  <div>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <h5 class="mb-5">Formas de Pagamento</h5>
          <ul class="centerx">
            <li
              class="mb-2"
              v-for="(item, index) in listaProdutosMensais"
              :key="index"
            >
              <label for="" class="vs-select--label">{{
                item.nomeProduto
              }}</label>
              <v-select
                :options="item.formas"
                :name="item.nomeProduto"
                :id="item.nomeProduto"
                v-model="item.valor"
                label="text"
                :reduce="(item) => item.value"
                @input="reatribuiFormaPagamentoMensal(item)"
              ></v-select>
            </li>
          </ul>
          <ul class="centerx">
            <li
              class="mb-2"
              v-for="(item, index) in listaProdutosAAvista"
              :key="index"
            >
              <label for="" class="vs-select--label">{{
                item.nomeProduto
              }}</label>
              <v-select
                :options="item.formas"
                :name="item.nomeProduto"
                :id="item.nomeProduto"
                v-model="item.valor"
                label="text"
                :reduce="(item) => item.value"
                @input="reatribuiFormaPagamento(false, item)"
              ></v-select>
            </li>
          </ul>
          <div v-if="hasCartaoCredito">
            <vs-button color="success" @click="modalCreditCard = true"
              >+ Adicionar Cartão</vs-button
            >
            <div v-if="listCartoes.length == 0" class="mt-3 alert alert-danger">
              <vs-alert
                title="Atenção!!"
                active="true"
                class="my-3"
                style="height: auto !important"
                color="danger"
              >
                Nenhum Cartão Encontrado
              </vs-alert>
            </div>
            <div v-else class="mt-3 alert alert-info">
              <vs-alert
                title="Atenção!!"
                active="true"
                class="my-3"
                style="height: auto !important"
                color="primary"
              >
                Selecione um dos Cartões para continuar o Processo
              </vs-alert>
            </div>
            <ul class="centerx">
              <li
                v-for="item in listCartoes"
                :key="item.id"
                :class="`item-lista ${
                  item.selecionado == true ? 'bg-success' : ''
                }`"
              >
                {{ item.cardNumber }}
                <vs-chip color="primary mr-3">{{ item.bandeira }}</vs-chip>
              </li>
            </ul>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-10">
          <label for="" class="vs-select--label"
            >Dia de Vencimento Mensal</label
          >
          <v-select
            :options="diasDeVencimentoEmpresa"
            name="diaVencimentoMensalidade"
            id="diaVencimentoMensalidade"
            v-model="form.diaVencimentoMensalidade"
            @input="reatribuiDiaVencimento()"
          ></v-select>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import service from './../../services';
import functions from './../../utils/functions';
import locale from './../../locale';
import vSelect from 'vue-select';

export default {
  props: ['dadosProposta', 'produtosSelecionados', 'recarregaFinanceiro'],
  components: {
    'v-select': vSelect,
  },
  watch: {
    buscaFormasPagamentoConfigEmpresa: function (newValue) {
      if (newValue) {
        this.buscaFormasPagamento(
          this.dadosProposta.idEmpresa,
          this.dadosProposta.idProposta,
        );
        this.buscaConfigEmpresa();
      }
    },
  },
  computed: {
    buscaFormasPagamentoConfigEmpresa() {
      return (
        this.dadosProposta.idEmpresa != null &&
        this.dadosProposta.idProposta != null
      );
    },
  },
  data() {
    return {
      functions: functions,
      diasDeVencimentoEmpresa: [],
      listaProdutosMensais: [],
      listaProdutosAAvista: [],
      hasCartaoCredito: false,
      jsonFacilitadorProdutos: [],
      produtos: [],
      produtosAtualizaModel: [],
      form: {
        diaVencimentoMensalidade: null,
      },
    };
  },
  methods: {
    async selecionaTipoPagamemto(formaPagamento) {
      return new Promise((resolve) => {
        if (Symbol.iterator in Object(formaPagamento)) {
          const [_formaPagamento] = formaPagamento;
          resolve(_formaPagamento);
        } else {
          resolve(formaPagamento);
        }
      });
    },
    filtraProdutos(prazoPagamento, formaPagamento) {
      return this.produtos.filter(
        (produto) =>
          ((produto.isMensal || produto.ismensal) === prazoPagamento &&
            produto.idProduto == formaPagamento.idProduto) ||
          produto.nomeProduto == formaPagamento.nomeProduto,
      );
    },
    identificarProduto(id_Produto) {
      const index = this.produtos.findIndex(
        (produto) => produto.idProduto == id_Produto,
      );
      return index;
    },
    adicionaFormaPagamentoAvista(idProduto, formaPagamento) {
      this.produtos.forEach((element) => {
        if (element.idProduto == idProduto || element.id_produto == idProduto) {
          element.nomePagamento = formaPagamento.valor
            ? formaPagamento.valor.tipoPagamento
            : null;
          element.idTipoPagamentoEmpresa = formaPagamento.valor
            ? formaPagamento.valor.idTipoPagamentoEmpresa
            : null;
        }
      });
    },
    reatribuiDiaVencimento() {
      this.emitChangeVencimento(this.form.diaVencimentoMensalidade);
    },
    reatribuiFormaPagamentoMensal(item) {
      this.produtos = this.produtos.map((produto) =>
        produto.isMensal == true || produto.ismensal == true
          ? {
              ...produto,
              nomePagamento: item.valor ? item.valor.tipoPagamento : null,
              idTipoPagamentoEmpresa: item.valor
                ? item.valor.idTipoPagamentoEmpresa
                : null,
            }
          : produto,
      );
      this.emitChangedForm('produtosSelecionados', this.produtos);
    },
    async reatribuiFormaPagamento(isMensal, item) {
      if (item.nomeProduto == 'Entrada') {
        this.produtos = this.produtos.map((produto) =>
          produto.isMensal == false || produto.ismensal == false
            ? {
                ...produto,
                nomePagamento: item.valor ? item.valor.tipoPagamento : null,
                idTipoPagamentoEmpresa: item.valor
                  ? item.valor.idTipoPagamentoEmpresa
                  : null,
              }
            : produto,
        );
      } else {
        const formaPagamento = await this.selecionaTipoPagamemto(item); // Retorna a primeira posição do array item(Array Produtos Avista || Mensal) Com novo valor

        this.adicionaFormaPagamentoAvista(item.idProduto, formaPagamento);
      }
      this.emitChangedForm('produtosSelecionados', this.produtos);
    },
    emitChangedForm(id, value, formulario = 'dadosProduto') {
      this.$emit('changed', { formulario, id, value });
    },
    emitChangeVencimento(diaVencimento) {
      this.$emit('alteraVencimento', diaVencimento);
    },
    buscaConfigEmpresa() {
      try {
        service
          .getAll(
            'g',
            {},
            'empresas/list/idEmpresa/' + this.dadosProposta.idEmpresa,
          )
          .then((res) => {
            if (res.data[0].diasVencimento) {
              if (
                functions.verificaEmpresaBemProtege(
                  this.dadosProposta.idEmpresa,
                )
              ) {
                this.diasDeVencimentoEmpresa = this.optionsDiasVencimento(
                  res.data[0].diasVencimento,
                );
              } else {
                this.diasDeVencimentoEmpresa =
                  res.data[0].diasVencimento.split(',');
              }
            }
            if (res.data[0].qtdDiasVencimentoAvista) {
              this.qtdDiasVencimentoAvistaEmpresa =
                res.data[0].qtdDiasVencimentoAvista;
            }
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `'Não foi possível buscar as configurasções da empresa, tente novamente.'`,
              color: 'danger',
            });
          });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `'Não foi possível buscar as configurasções da empresa, tente novamente.'`,
          color: 'danger',
        });
      }
    },
    optionsDiasVencimento(arrayDiasVencimento) {
      const dataVistoria = new Date();
      const diaDoMesVistoria = dataVistoria.getDate();
      const arrStr = arrayDiasVencimento
        .split(',')
        .map(Number) // aqui converto o array de strings em numbers
        .sort((a, b) => a - b); // ordeno do menor para o maior
      if (diaDoMesVistoria >= 1 && diaDoMesVistoria <= 31) {
        const maxDay = Math.min(diaDoMesVistoria, 31); // seta o maxDay baseado no dia atual garantindo que seja menor que 31

        const novoArrayVencimento = arrStr.filter(
          (element) => element <= maxDay + 4 && maxDay - element <= 5,
        );
        if (diaDoMesVistoria >= 16) novoArrayVencimento.push(10);
        if (diaDoMesVistoria >= 21) novoArrayVencimento.push(15);
        if (diaDoMesVistoria >= 26) novoArrayVencimento.push(20);

        return novoArrayVencimento.sort((a, b) => a - b);
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    preencheForm() {
      this.produtos = this.produtosSelecionados;
      this.form.diaVencimentoMensalidade =
        this.dadosProposta.diaVencimentoMensalidade;
    },
    async buscaFormasPagamento(idEmpresa, idProposta) {
      if (!idEmpresa && !idProposta) {
        return;
      } else {
        await service
          .post('Cotacao', 'buscaFormasPagamento', {
            idEmpresa: idEmpresa,
            idProposta: idProposta,
          })
          .then(async (res) => {
            res.data.cobrancaValoresAntesDaVistoria = false; // TESTE COM LUCAS, RETIRAR.
            this.cobrancaValoresAntesDaVistoria =
              res.data.cobrancaValoresAntesDaVistoria;
            this.listCartoes = res.data.cartoes;
            let formas = res.data.formasPagamento;
            let aux = [];

            if (this.cobrancaValoresAntesDaVistoria == false)
              for (let index = 0; index < formas.length; index++) {
                const element = formas[index];
                let valor = null;

                if (this.dadosFinanceiros)
                  if (element.isMensal) {
                    let findValor = this.dadosFinanceiros.mensais.find(
                      (x) => x.nomeProduto == element.nomeProduto,
                    );
                    if (findValor) valor = findValor.valor;
                  } else {
                    let findValor = this.dadosFinanceiros.avista.find(
                      (x) => x.nomeProduto == element.nomeProduto,
                    );
                    if (findValor) valor = findValor.valor;
                  }

                if (index == 0) {
                  aux.push({
                    idProduto: element.idProduto,
                    nomeProduto: element.nomeProduto,
                    isMensal: element.isMensal,
                    valor: valor,
                    formas: [
                      {
                        value: {
                          idTipoPagamentoEmpresa:
                            element.id_tipoPagamentoEmpresa,
                          tipoPagamento: element.nomePagamento,
                        },
                        text: element.nomePagamento,
                      },
                    ],
                  });
                } else {
                  if (element.nomeProduto == formas[index - 1].nomeProduto) {
                    let aux2 = aux.find(
                      (x) => x.nomeProduto == element.nomeProduto,
                    );
                    aux2.formas.push({
                      value: {
                        idTipoPagamentoEmpresa: element.id_tipoPagamentoEmpresa,
                        tipoPagamento: element.nomePagamento,
                      },
                      text: element.nomePagamento,
                    });
                  } else {
                    aux.push({
                      idProduto: element.idProduto,
                      nomeProduto: element.nomeProduto,
                      isMensal: element.isMensal,
                      valor: valor,
                      formas: [
                        {
                          value: {
                            idTipoPagamentoEmpresa:
                              element.id_tipoPagamentoEmpresa,
                            tipoPagamento: element.nomePagamento,
                          },
                          text: element.nomePagamento,
                        },
                      ],
                    });
                  }
                }
              }
            this.listaProdutosMensais = [];
            this.listaProdutosAAvista = [];
            aux.forEach((element) => {
              if (element.isMensal) {
                this.listaProdutosMensais.push(element);
              } else {
                this.listaProdutosAAvista.push(element);
              }
            });
            if (this.listaProdutosMensais.length > 0)
              this.listaProdutosMensais.forEach((element) => {
                element.formas.unshift({ value: null, text: 'Selecione' });
              });

            if (this.listaProdutosAAvista.length > 0)
              this.listaProdutosAAvista.forEach((element) => {
                element.formas.unshift({ value: null, text: 'Selecione' });
              });
            this.buscaConfigEmpresa();
            this.preencheForm();
            await this.atualizaModel();
          });
      }
    },
    async atualizaModel() {
      this.produtosAtualizaModel = [];
      this.produtosAtualizaModel = this.dadosProposta.produtos;
      await Promise.all(
        this.listaProdutosAAvista.map(async (produtoAVista) => {
          if (produtoAVista.nomeProduto == 'Entrada') {
            const produtoEncontrado = this.produtosAtualizaModel.find(
              (produto) => {
                return (
                  (produto.ismensal == false || produto.isMensal == false) &&
                  produto.idTipoPagamentoEmpresa
                );
              },
            );
            if (produtoEncontrado) {
              let formaEncontrada = produtoAVista.formas.find((forma) => {
                return forma.text == produtoEncontrado.nomePagamento;
              });
              if (formaEncontrada) produtoAVista.valor = formaEncontrada.value;
            }
          } else {
            const produtoEncontrado = this.produtosAtualizaModel.find(
              (produto) => {
                return (
                  (produto.idProduto || produto.id_produto) ==
                  (produtoAVista.idProduto || produtoAVista.id_produto)
                );
              },
            );
            if (produtoEncontrado && produtoEncontrado.idTipoPagamentoEmpresa) {
              let formaEncontrada = produtoAVista.formas.find((forma) => {
                return forma.text == produtoEncontrado.nomePagamento;
              });
              if (formaEncontrada) produtoAVista.valor = formaEncontrada.value;
            }
          }
        }),
      );

      await Promise.all(
        this.listaProdutosMensais.map(async (produtoMensal) => {
          const produtoEncontrado = this.produtosAtualizaModel.find(
            (produto) => {
              return (produto.isMensal || produto.ismensal) == true;
            },
          );
          if (produtoEncontrado.idTipoPagamentoEmpresa) {
            let formaEncontrada = produtoMensal.formas.find((forma) => {
              return forma.text == produtoEncontrado.nomePagamento;
            });
            produtoMensal.valor = formaEncontrada.value;
          }
        }),
      );
    },
    verificaTipoPagamento() {
      this.hasCartaoCredito = false;
      this.isBoletoAVista = false;
      this.btnDisabled = false;

      this.listaProdutosMensais.forEach((element) => {
        if (element.valor) {
          if (element.valor.tipoPagamento == 'Cartão de Crédito') {
            this.hasCartaoCredito = true;
            this.isCartaoMensal = true;
            this.btnDisabled = true;
            if (this.filtraCartoesSelecionados().length > 0)
              this.btnDisabled = false;
          }
        }
      });
      this.listaProdutosAAvista.forEach((element) => {
        if (element.valor) {
          if (element.valor.tipoPagamento == 'Cartão de Crédito') {
            this.hasCartaoCredito = true;
            this.isCartaoAvista = true;
            this.btnDisabled = true;
            if (this.filtraCartoesSelecionados().length > 0)
              this.btnDisabled = false;
          }
          if (element.valor.tipoPagamento == 'Boleto') {
            this.isBoletoAVista = true;
            this.restringeDatas();
          }
        }
      });
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    this.buscaFormasPagamento(
      this.dadosProposta.idEmpresa,
      this.dadosProposta.idProposta,
    );
  },
  created() {},
};
</script>
<style scoped lang="scss">
.vdp-datepicker input {
  width: 100%;
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
